import { useMutation, useQueryClient } from 'react-query';
import { ToastContext } from 'app/components/Context/ToastContext';
import { useContext } from 'react';
import { CreateCommunityComment } from 'services/apiServices';
import {
  TCreateCommentResult,
  Errors,
  CreateCommentParams,
} from 'types/ApiServicesTypes';

export default function useCreateCommunityComment() {
  const { showAlert } = useContext(ToastContext);
  const queryClient = useQueryClient();

  const mutation = useMutation<
    TCreateCommentResult, 
    Errors, 
    { params: CreateCommentParams; ideaId?: number; strategyId?: number }
  >(
    ['CreateCommunityComment'],
    ({ params, ideaId, strategyId }) =>
      CreateCommunityComment(params, ideaId, strategyId)
        .then(res => {
          showAlert!('Comment added successfully', 'success');
          // Invalidate and refetch comments for the specific post
          void queryClient.invalidateQueries(['GetCommunityComments']);
          // Also invalidate the specific post to update comment count
          if (ideaId) {
            void queryClient.invalidateQueries(['GetCommunityIdea', ideaId]);
          }
          if (strategyId) {
            void queryClient.invalidateQueries(['GetCommunityStrategy', strategyId]);
          }
          return res;
        })
        .catch(err => {
          showAlert!(err.message as string);
          return err;
        }),
  );

  if (mutation.isError && mutation.error) {
    showAlert!(mutation.error.message);
  }

  return mutation;
} 